import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showTileView: false,
  tileId: '',
  currentTab: '',
};

const tileViewSlice = createSlice({
  name: 'tileView',
  initialState,
  reducers: {
    showTileView(state, { payload }) {
      return {
        showTileView: true,
        tileId: payload.tileId,
        currentTab: payload.currentTab,
      };
    },
    hideTileView() {
      return {
        showTileView: false,
        tileId: '',
        currentTab: '',
      };
    },
  },
});

export const { showTileView, hideTileView } = tileViewSlice.actions;
export default tileViewSlice.reducer;
